<template>
  <div class="openingStatusBox" :style="{'--boxCount':hideRight?4:5}">
    <div class="left">
      <div class="arrow" :style="{'--b':'-135deg'}" v-if="showLeftArrow" @click="previous"></div>
      <div class="openingList">
        <el-tooltip class="item" effect="light" :content="item.tip" :hide-after="+!item.tip"
                    placement="top" v-for="(item,index) in currentList" :key="index">
          <div class="openingStatus" >
            <div class="contentBox">
              <div class="title">{{ item.content }}</div>
              <div class="content">{{ item.title }}</div>
            </div>
            <div class="icon">
              <img :src="require(`@/assets/icon/icon_${item.icon}.png`)">
            </div>
          </div>
        </el-tooltip>
      </div>
      <div class="arrow" :style="{'--b':'45deg'}" v-if="showRightArrow" @click="next"></div>
      <div class="line" v-if="showRightArrow && !hideRight"></div>
    </div>
    <div class="right" v-if="!hideRight">
      <div class="contentBox">
        <div class="title">
          <span>{{ ranking.score || 0 }}</span>
          <span>/{{ ranking.totalNum || 0 }}</span>
        </div>
        <div class="content">{{ ranking.title }}</div>
      </div>
      <div class="icon">
        <img :src="require(`@/assets/icon/icon_ranking.png`)">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "mOpeningStatus",
  props: {
    ranking: {
      type: Object,
      default: () => ({
        score: '0', totalNum: '0'
      })
    },
    leftList: {
      type: Array,
      default: () => ([])
    },
    hideRight: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      showLeftArrow: false,
      showRightArrow: false,
      currentList: [],
      currentIndex: 0
    }
  },
  mounted() {
    this.currentList = this.leftList.slice(0, 4)
    this.showRightArrow = this.leftList.length > 4
  },
  methods: {
    previous() {
      if (4 + this.currentIndex > 4) {
        this.currentList = this.leftList.slice(--this.currentIndex, 4 + this.currentIndex)
        this.showRightArrow = this.currentList[this.currentList.length - 1] !== this.leftList[this.leftList.length - 1]
        this.showLeftArrow = !this.showRightArrow
      }
    },
    next() {
      if (4 + this.currentIndex < this.leftList.length) {
        this.currentList = this.leftList.slice(++this.currentIndex, 4 + this.currentIndex)
        this.showRightArrow = this.currentList[this.currentList.length - 1] !== this.leftList[this.leftList.length - 1]
        this.showLeftArrow = !this.showRightArrow
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.openingStatusBox {
  display: grid;
  grid-template-columns: repeat(var(--boxCount), 1fr);
  gap: calc(0.12 * var(--fontSize));
  width: 100%;
  height: 100%;

  .left {
    grid-column: 1/4 span;
    height: 100%;
    display: flex;
    align-items: center;

    .openingList {
      width: 100%;
      height: 100%;
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: calc(0.12 * var(--fontSize));
      cursor: pointer;

      & > .openingStatus {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px;
        height: calc(1.09 * var(--fontSize));
        width: 100%;
        border-radius: 6px;
        background: linear-gradient(180deg, rgba(243, 245, 247, 1) 0%, rgba(243, 245, 247, 1) 9.91%, rgba(254, 254, 255, 1) 100%);
        border: 1px solid rgba(255, 255, 255, 1);
        box-shadow: -4px -4px 10px 0px rgba(255, 255, 255, 0.8), 4px 4px 10px 0px rgba(222, 221, 227, 1);
        box-sizing: border-box;
        position: relative;

        & > .contentBox {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: calc(0.45 * var(--fontSize));

          & > .title {
            font-size: calc(0.16 * var(--fontSize));
            display: flex;
            align-items: center;
          }

          & > .content {
            font-size: calc(0.12 * var(--fontSize));
            color: rgba(166, 166, 166, 1);
          }
        }

        .icon {
          display: flex;
          justify-content: center;
          align-items: center;
          height: calc(0.70 * var(--fontSize));
          width: calc(0.70 * var(--fontSize));
          border-radius: 15px;
          background: rgba(255, 255, 255, 1);
          box-shadow: 0px 2px 4px 0px rgba(230, 238, 255, 1);

          img {
            width: calc(0.40 * var(--fontSize));
            height: calc(0.40 * var(--fontSize));
          }
        }
      }


      & > .openingStatus:hover {
        background: linear-gradient(180deg, rgb(230, 233, 238) 0%, rgb(238, 242, 246) 9.91%, rgba(254, 254, 255, 1) 100%);
        .icon {
          transform-origin: center;
          animation: shake .8s infinite linear alternate;

          img {
            transition: .5s;
            transform: scale(1.2);
            animation: twinkle .8s infinite linear alternate;
          }
        }
      }
    }

    .arrow {
      height: calc(1.07 * var(--fontSize));
      width: calc(0.37 * var(--fontSize));
      border-radius: 6px;
      background: linear-gradient(180deg, #F3F5F7 0%, #F3F5F7 9.91%, #FEFEFF 100%);
      border: 1px solid #FFFFFF;
      box-shadow: -4px -4px 10px 0px #FFFFFF, 4px 4px 10px 0px #DEDDE3;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 10px;
      cursor: pointer;
      transition: .3s;

      &:before {
        content: '';
        height: calc(0.12 * var(--fontSize));
        width: calc(0.12 * var(--fontSize));
        border-top: 3px solid #000000;
        border-right: 3px solid #000000;
        border-radius: 3px;
        transform: rotate(var(--b));
      }
    }

    .arrow:hover {
      background: linear-gradient(180deg, #e9ebee 0%, #ebeff3 9.91%, #FEFEFF 100%);
    }

    .line {
      height: calc(1.07 * var(--fontSize));
      width: 1px;
      background-color: rgba(166, 166, 166, 0.5);
    }
  }

  .right {
    width: 100%;
    height: calc(1.09 * var(--fontSize));
    border-radius: 10px;
    background: linear-gradient(108.9deg, rgba(254, 216, 111, 1) 0%, rgba(250, 186, 19, 1) 100%);
    border: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    box-sizing: border-box;
    cursor: pointer;

    & > .contentBox {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: calc(0.55 * var(--fontSize));
      color: white;

      & > .title {
        margin-left: -3px;
        font-size: calc(0.14 * var(--fontSize));

        & > span:first-child {
          font-size: calc(0.34 * var(--fontSize));
          margin-right: -6px;
        }
      }

      & > .content {
        font-size: calc(0.12 * var(--fontSize));
        color: white;
      }
    }

    .icon {
      width: auto;
      height: auto;
      background-color: transparent;
      box-shadow: 0 0 0 0;

      img {
        width: calc(1.01 * var(--fontSize));
        height: calc(0.65 * var(--fontSize));
      }
    }
  }

  & > .right:hover {
    .icon {
      transform-origin: center;
      animation: shake .8s infinite linear alternate;

      img {
        transition: .5s;
        transform: scale(1.2);
        animation: twinkle .8s infinite linear alternate;
      }
    }
  }

  @keyframes twinkle {
    to {
      filter: contrast(128%);
    }
  }
  @keyframes shake {
    from {
      transform: translateX(-5px) rotate(-15deg);
    }
    to {
      transform: translateX(5px) rotate(15deg);
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/new_account_settings/accountSettings/overallStatistics/components/mOpeningStatus.vue